import { inject, Injectable } from '@angular/core';
import { AuthService } from '../authentication/auth.service';

/** Who is looking at a dashboard: decides widget permissions. */
export interface DashboardAccess {
  /** An empty list is always allowed */
  hasPermissions(permissions: readonly string[]): boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthDashboardAccess implements DashboardAccess {
  private readonly auth = inject(AuthService);

  hasPermissions(permissions: readonly string[]): boolean {
    return permissions.length === 0 || this.auth.hasAllPermissions([...permissions]);
  }
}
